export type Position = 'left' | 'right' | 'top' | 'bottom';

const OFFSET = 18; // triangle (10px) + 8px gap

export const getTooltipPosition = (
  position: Position,
  ref: Element,
  wrapperRef: Element,
) => {
  const wrapperEl = {
    offsetY: wrapperRef.getBoundingClientRect().y,
    offsetX: wrapperRef.getBoundingClientRect().x,
    width: wrapperRef.clientWidth,
    height: wrapperRef.clientHeight,
  };

  switch (position) {
    case 'left':
      return {
        top: wrapperEl.offsetY + wrapperEl.height / 2 - ref.clientHeight / 2,
        left: wrapperEl.offsetX + -1 * ref.clientWidth - OFFSET,
      };

    case 'right':
      return {
        top: wrapperEl.offsetY + wrapperEl.height / 2 - ref.clientHeight / 2,
        left: wrapperEl.offsetX + wrapperEl.width + OFFSET,
      };

    case 'top':
      return {
        top: wrapperEl.offsetY + -1 * ref.clientHeight - OFFSET,
        left: wrapperEl.offsetX + wrapperEl.width / 2 - ref.clientWidth / 2,
      };

    case 'bottom':
      return {
        top: wrapperEl.offsetY + wrapperEl.height + OFFSET,
        left: wrapperEl.offsetX + wrapperEl.width / 2 - ref.clientWidth / 2,
      };
  }
};

const isScrollable = (node: Element) => {
  const style = window.getComputedStyle(node);
  const overflowY = style?.overflowY;
  const overflowX = style?.overflowX;

  return (
    ((overflowY === 'scroll' || overflowY === 'auto') &&
      node.scrollHeight > node.clientHeight) ||
    ((overflowX === 'scroll' || overflowX === 'auto') &&
      node.scrollWidth > node.clientWidth)
  );
};

export const getScrollableParents = (
  node: Element | null,
  elements: Element[] = [],
): Element[] => {
  if (!node || node === document.body) return [...elements, document.body];
  return isScrollable(node)
    ? getScrollableParents(node.parentNode as Element | null, [
        ...elements,
        node,
      ])
    : getScrollableParents(node.parentNode as Element | null, elements);
};
